import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import categories1 from "../../locales/RestaurantCategories.json";
import { authCall } from "../../services";

const categories = [
  {
    id: 1,
    name: "africanCuisine",
    label: "African",
  },
  {
    id: 2,
    name: "americanCuisine",
    label: "American",
  },
  {
    id: 3,
    name: "arabCuisine",
    label: "Arab",
  },
  {
    id: 4,
    name: "australiaCuisine",
    label: "Australian",
  },
  {
    id: 5,
    name: "bowlingClub",
    label: "Bowling Club",
  },
  {
    id: 6,
    name: "burgerBar",
    label: "Burgers",
  },
  {
    id: 7,
    name: "chineseCuisine",
    label: "Chinese",
  },
  {
    id: 8,
    name: "egyptianCuisine",
    label: "Egyptian",
  },
  {
    id: 9,
    name: "fastFood",
    label: "Fast Food",
  },
  {
    id: 10,
    name: "frenchCuisine",
    label: "French",
  },
  {
    id: 11,
    name: "germanCuisine",
    label: "German",
  },
  {
    id: 12,
    name: "greekCuisine",
    label: "Greek",
  },
  {
    id: 13,
    name: "indianCuisine",
    label: "Indian",
  },
  {
    id: 14,
    name: "indonesianCuisine",
    label: "Indonesian",
  },
  {
    id: 15,
    name: "irishBar",
    label: "Irish Bar",
  },
  {
    id: 16,
    name: "italianCuisine",
    label: "Italian",
  },
  {
    id: 17,
    name: "japaneseCuisine",
    label: "Japanese",
  },
  {
    id: 18,
    name: "koreanCuisine",
    label: "Korean",
  },
  {
    id: 19,
    name: "mexicanCuisine",
    label: "Mexican",
  },
  {
    id: 20,
    name: "rsl",
    label: "RSL/Surf Club",
  },
  {
    id: 21,
    name: "seafood",
    label: "Seafood",
  },
  {
    id: 22,
    name: "spanishCuisine",
    label: "Spanish",
  },
  {
    id: 23,
    name: "sportsBar",
    label: "Sports Bar/Pub",
  },
  // {
  //   id: 24,
  //   name: "surfClub",
  //   label: "Surf Club",
  // },
  {
    id: 25,
    name: "sushiBar",
    label: "Sushi",
  },
  {
    id: 26,
    name: "tapas",
    label: "Tapas",
  },
  {
    id: 27,
    name: "thaiCuisine",
    label: "Thai",
  },
  {
    id: 28,
    name: "dinnerAndShow",
    label: "Dinner & Show",
  },
  {
    id: 29,
    name: "turkishCuisine",
    label: "Turkish",
  },
  {
    id: 30,
    name: "vitaminiseCuisine",
    label: "Vitaminise",
  },
  {
    id: 31,
    name: "weddingVenue",
    label: "Wedding Venue",
  },
  {
    id: 32,
    name: "cafédining",
    label: "Tea/Coffee",
  },
  {
    id: 33,
    name: "desertrestaurantcafé",
    label: "Deserts",
  },
  {
    id: 34,
    name: "colombiancuisine",
    label: "Colombian",
  },
  {
    id: 35,
    name: "cubancuisine",
    label: "Cuban",
  },
  {
    id: 36,
    name: "asianfusion",
    label: "Asian Fusion",
  },
  {
    id: 37,
    name: "malaysiancuisine",
    label: "Malaysian",
  },
  {
    id: 38,
    name: "europeancuisine",
    label: "European",
  },
  {
    id: 39,
    name: "mediterraneancuisine",
    label: "Mediterranean",
  },
  {
    id: 40,
    name: "mongoliancuisine",
    label: "Mongolian",
  },
  {
    id: 41,
    name: "steakhouse",
    label: "Steakhouse",
  },
  {
    id: 42,
    name: "filipinocuisine",
    label: "Filipino",
  },
  {
    id: 43,
    name: "braziliancuisine",
    label: "Brazilian",
  },
  {
    id: 44,
    name: "persiancuisine",
    label: "Persian",
  },
  {
    id: 45,
    name: "vegetarian",
    label: "Vegetarian",
  },
  {
    id: 46,
    name: "icecream",
    label: "Ice Cream",
  },
  {
    id: 47,
    name: "pizza",
    label: "Pizza",
  },
  {
    id: 48,
    name: "halalcuisine",
    label: "Halal",
  },
  {
    id: 49,
    name: "kebabs",
    label: "Kebabs",
  },
  {
    id: 50,
    name: "fishChips",
    label: "Fish & Chips",
  },
  {
    id: 51,
    name: "ramen",
    label: "Ramen",
  },
  {
    id: 52,
    name: "teppanyaki",
    label: "Teppanyaki",
  },
  {
    id: 53,
    name: "buffet",
    label: "Buffet",
  },
  {
    id: 54,
    name: "Café",
    label: "Café",
  },
];

// Sort by 'label' in ascending orde
// const CATEGORIES = categories.sort((a, b) => {
//   return a.label.localeCompare(b.label);
// });

// CATEGORIES.push({
//   id: 49,
//   name: "other",
//   label: "Other",
// });

function RestaurantCategoryComp({
  onSubmit,
  loading,
  details,
  Sidebar,
  buttons,
}) {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [otherValue, setOtherValue] = useState("");
  const [loadingCat, setLoadingCat] = useState(false);
  const [CATEGORIES, SETCATEGORIES] = useState([]);

  useEffect(() => {
    async function fetchData() {
      setLoadingCat(true);
      const resp = await authCall("categories", {
        type: "restaurant",
      });
      if (resp?.type === "success") {
        setLoadingCat(false);
        const categories = resp?.payload;
        categories.push({
          id: 49,
          name: "other",
          label: "Other",
        });
        SETCATEGORIES(resp?.payload);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    setSelectedCategories(details?.categories || []);
    setOtherValue(details?.restaurant_category_other || "");
  }, [details]);

  const handleCheckboxChange = (option) => {
    // setSelectedCategories(value);
    setSelectedCategories((prev) =>
      prev.some((item) => item.name === option.name)
        ? prev.filter((item) => item.name !== option.name)
        : [...prev, option]
    );
  };

  const handleSubmit = async () => {
    if (selectedCategories === "") {
      toast.dismiss();
      toast.error("Please select category.");
    } else {
      const data = {
        // restaurantCategories: selectedCategories,
        categories: selectedCategories,
        restaurantCategoryOther: otherValue,
      };
      onSubmit(data);
    }
  };

  return (
    <>
      <div className="restaurant-category-page py-4">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <Sidebar details={details} />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">
                  Which Category Best Represents Your Restaurant?
                </div>
                <div className="details-wrapper">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="fs-18">
                      Please select the most relevant categories from the list
                      below:
                    </div>
                    {details?.name && (
                      <div className="fs-18 main-heading2">{details?.name}</div>
                    )}
                  </div>

                  {/* <div className="fs-18 mb-4">
                    Please select the most relevant categories from the list
                    below:
                  </div>
                  <div className="fs-18 mb-4">
                  Activity name
                  </div> */}
                  <div action="">
                    {!loadingCat && (
                      <>
                        <div className="row row-cols-sm-2 row-cols-lg-3">
                          {CATEGORIES.map((cat) => (
                            <div
                              key={cat.id}
                              className="form-group d-flex align-items-center gap-3"
                            >
                              <input
                                type="checkbox"
                                // type="radio"
                                // className="custom-radio m-0 cursor-pointer"
                                // name={cat.name}
                                name="restaurantCategories"
                                id={cat.name}
                                value={cat.label}
                                // checked={selectedCategories === cat.label}
                                checked={selectedCategories.some(
                                  (item) => item.name === cat.name
                                )}
                                onChange={(e) => handleCheckboxChange(cat)}
                              />
                              <label
                                // className="form-check-label m-0"
                                className="m-0"
                                htmlFor={cat.name}
                              >
                                {cat.label}
                              </label>
                            </div>
                          ))}
                        </div>
                        {selectedCategories === "Other" && (
                          <input
                            type="text"
                            className="form-control form-group d-flex align-items-center gap-3"
                            style={{ width: 250 }}
                            id="categoryName"
                            name="categoryName"
                            placeholder="Add Category..."
                            autoComplete="off"
                            value={otherValue}
                            onChange={(e) => setOtherValue(e.target.value)}
                          />
                        )}
                      </>
                    )}
                    {loadingCat && (
                      <div className="text-center" style={{ padding: 150 }}>
                        Loading...
                      </div>
                    )}
                    <div className="btn-wrapper text-center my-2">
                      {buttons.map((button) => (
                        <button
                          key={button.id}
                          onClick={handleSubmit}
                          className="btn btn-custom"
                          disabled={loading || false}
                        >
                          {loading ? "Loading..." : button.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RestaurantCategoryComp;
